export default "/assets/images/technology-graph-05.jpg?3f4335d1cc9a225406f9782780a6320f";